export const EMPTY_TITLE_PLACEHOLDER = 'Untitled';
export const DATABASE_TITLE_LENGTH = 50;
